export const config = {
    instrumentationKey: 'df0444ee-40ba-4690-8cb6-e6daa703d38d'
};